// extracted by mini-css-extract-plugin
export var attached = "BetslipSection-module--attached--2d550";
export var badge = "BetslipSection-module--badge--7494a";
export var caret = "BetslipSection-module--caret--5a935";
export var content = "BetslipSection-module--content--217db";
export var count = "BetslipSection-module--count--2ce74";
export var header = "BetslipSection-module--header--e8faa";
export var label = "BetslipSection-module--label--87155";
export var section = "BetslipSection-module--section--5d861";
export var standalone = "BetslipSection-module--standalone--0014f";